var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85 12H8.15C10.9 12 12 10.9 12 8.15V4.85C12 2.1 10.9 1 8.15 1H4.85C2.1 1 1 2.1 1 4.85V8.15C1 10.9 2.1 12 4.85 12Z",
    stroke: "#FF0000",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21484 5.17356C8.2898 5.07468 7.36067 5.02516 6.43095 5.02518C5.8801 5.02518 5.32925 5.05665 4.78264 5.11511L4.21484 5.17356M5.7445 4.8768L5.80383 4.49011C5.8462 4.21133 5.8801 4 6.35044 4H7.07925C7.54959 4 7.58349 4.22032 7.62586 4.49011L7.68518 4.8723M8.61739 5.20953L8.43518 8.17716C8.40552 8.64029 8.3801 9 7.60467 9H5.82078C5.04535 9 5.01993 8.64029 4.99027 8.17716L4.80806 5.20953",
    stroke: "#FF0000",
    strokeOpacity: 0.7,
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f74d02a3f1c8f32c235391abc1f66aab.svg";
export { ForwardRef as ReactComponent };